//#region importSection
import React, { useEffect } from "react";
import Draggable from "react-draggable";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { GetLanguageString } from "../helper/Components";
import { useState } from "react";
import { LoadingSpinner } from "../../constants/const";

import ApiSyllabusBook from "../config/setupsyllabus/ApiSetupBook";
import { SweetAlertComponent } from "../config/SweetAlertComponent";
//#endregion importSection
const UpdateMemberNisab = ({ task, onClose, refreshBoard }) => {
  //#region declareStates
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [loading, setLoading] = useState(false);
  const [nisabBooks, setNisabBooks] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  //#endregion declareStates
  //#region useStates
  useEffect(() => {
    setLoading(true);
    ApiSyllabusBook()
      .GetMemberDawatiNisaabBooks({ MemberId: task.habibId })
      .then((res) => {
        setNisabBooks(res.data);
        const preChecked = res.data
          .filter((n) => n.isReading === true)
          .map((n) => n.id);
        setSelectedIds(preChecked);
        setLoading(false);
      });
  }, [setNisabBooks, task]);
  //#endregion useStates
  //#region functions
  const handleCheckboxChange = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };
  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };
  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    ApiSyllabusBook()
      .UpdateMemberDawatiNisaabBooks({
        SetupSyllabusBookIds: selectedIds,
        MemberId: task.habibId,
      })

      .then((res) => {
        if (res.data.statusCode === "200") {
          setLoading(false);
          if (typeof refreshBoard === "function") {
            refreshBoard();
          }
          SweetAlertComponent({
            messageKey: "dawati_nisab_updated",
            statusCode: res.data.statusCode,
          });
          onClose(true);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  //#endregion functions
  return (
    <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
      <Modal isOpen={true} className="inmodal" autoFocus={false}>
        <ModalHeader className="modal-title" tag="h4">
          <GetLanguageString props="update_dawati_nisab" />
        </ModalHeader>
        {!loading ? (
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              {nisabBooks.map((nisab) => (
                <FormGroup check key={nisab.id} className="mb-2">
                  <Label check className="ur">
                    <Input
                      type="checkbox"
                      value={nisab.id}
                      checked={selectedIds.includes(nisab.id)}
                      onChange={() => handleCheckboxChange(nisab.id)}
                    />
                    {nisab.syllabusBookName}
                  </Label>
                </FormGroup>
              ))}
            </ModalBody>
            <ModalFooter>
              <Button color="white" onClick={() => onClose(false)}>
                <GetLanguageString props="common_cancel" />
              </Button>
              <Button color="primary" type="submit">
                <GetLanguageString props="common_save" />
              </Button>{" "}
            </ModalFooter>
          </Form>
        ) : (
          LoadingSpinner()
        )}
      </Modal>
    </Draggable>
  );
};

export default UpdateMemberNisab;
